// Vendors
import { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React from 'react';
// Hooks
import { useCheckoutHook } from './hooks/checkout.hook';

const CheckoutProvider = ({ children }: ReactChildrenType): React.ReactNode => {
  useCheckoutHook();

  return children;
};

export { CheckoutProvider };
